<template>
  <div class="editor-canvas">
    <div ref="canvasRef" class="canvas-container"></div>
  </div>
</template>

<script setup lang="ts">
  import { useEditor, useExport } from '@/hooks';
  import { ref } from 'vue';

  const canvasRef = ref();

  const { getCanvas } = useEditor(canvasRef);
  useExport(getCanvas());
</script>

<style scoped>
  .editor-canvas {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    position: relative;
  }

  .canvas-container {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #ffffff;
    overflow: hidden;
  }
</style>
